@if (loadFailed()) {
  <div class="alert alert-danger" role="alert">The editor could not be loaded. Please refresh the page to try again.</div>
}
<div id="froala-editor"></div>

<ng-template #variablePickerModal let-modal>
  <app-iframe-modal-shell [src]="variablePickerUrl()" (close)="modal.dismiss('cancel')"></app-iframe-modal-shell>
</ng-template>
